import React from 'react';
import AppLoader from 'components/basic/AppLoader';
import CollectionKeys from 'hooks/molecules/collection-keys';
import { useItems } from 'hooks/atoms/items-hook';
import ManagersRegistrationsDetails from 'components/business/local-manager/ManagersRegistrationsDetails';
import { Typography } from '@material-ui/core';

function ManagersSerialDashboardResults({ searchSerial, country }) {
  // The Request
  const {
    itemsLoading: kitsLoading,
    items: kits,
    itemsFetching: kitsFetching,
  } = useItems(CollectionKeys.REGISTRATION_KITS, { filterQuery: {
    _where: [
      [{ 'serial_number_id.serial': searchSerial },
        { 'serial_number_id.country': country }],
    ],
  },
  queryOptions: { cacheTime: 0,
    staleTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false } });

  return (
    <>
      { (kitsLoading || kitsFetching) && <AppLoader />}
      {!kitsLoading && !kitsFetching && Array.isArray(kits) && kits.length > 0
      && <ManagersRegistrationsDetails kit={ kits[0] } />}
      {!kitsLoading && !kitsFetching && kits.length === 0 && (
        <Typography
          variant='h5'
          color='error'
        >
          Serial Not Found
        </Typography>
      )}
    </>
  );
}

export default ManagersSerialDashboardResults;
